import { Fragment, FunctionalComponent, h } from 'preact';
import { IntlContext } from 'preact-i18n';
import { useContext } from 'preact/hooks';
import { formatPoints, PointsProps } from './pointsFormatUtils';
import { FinText } from '../../i18n';

export const PointsFormat: FunctionalComponent<PointsProps> = ({ totalPoints, abbreviate }: PointsProps) => {
  const context = useContext(IntlContext);
  const formattedPrice = formatPoints(totalPoints, abbreviate, context);
  return (
    !!formattedPrice && (
      <Fragment>
        {formattedPrice}
        {!abbreviate && (
          <Fragment>
            {' '}
            <FinText id="award.pointsAmount" />
          </Fragment>
        )}
      </Fragment>
    )
  );
};
